module.exports = __webpack_public_path__ + "static/digma-links-65674b433035495fafa4f88a1670595a.png";